
import React from 'react';
import { Button } from "@/components/ui/button";

interface NavigationButtonsProps {
  onBack: () => void;
  onNext: () => void;
  isSaving: boolean;
}

export const NavigationButtons = ({ onBack, onNext, isSaving }: NavigationButtonsProps) => {
  return (
    <div className="flex justify-center items-center gap-4 mb-0 pb-0 my-[15px]">
      <Button onClick={onBack} className="w-32 bg-white text-secondary hover:bg-white/90">
        Back
      </Button>
      <Button onClick={onNext} className="w-32 bg-primary text-secondary hover:bg-primary-dark" disabled={isSaving}>
        {isSaving ? "Next" : "Next"}
      </Button>
    </div>
  );
};
